<template>
  <div style="background:#fff;">
    <!-- START - BANNER -->
    <Banner image="noche-1" />
    <!-- END - BANNER -->
    <v-container>
       <h1 class="display-1">Usuario y Categoría</h1>
      <v-row>
        <!-- usuario -->
        <v-col cols="12" sm="12" md="6">
          <div class="d-flex">
          <!-- <span class="display-1">usuario</span> -->
         
          </div>
          <User />
        </v-col>
        <!-- categoria -->
        <v-col cols="12" sm="12" md="6">
          <!-- <h1 class="display-1">categoria</h1> -->
          <Category />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Banner from '@/components/BannerBlog';
  import Category from '@/components/Category';
  import User from '@/components/User';
  export default {
    name:'dash',
    components:{Banner,Category,User},
    created(){
    },
    data(){
      return{
        
      }
    },
    methods:{
    }
  }
</script>

<style lang="scss" scoped>

</style>